import React from 'react'

export default function Up ({ className, fill }) {
  return (
    <svg fill={fill} className={className} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
      <path d='M12 3l12 18h-24z' />
    </svg>
  )
}

Up.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}
